import React, { useEffect, useRef, useState } from "react";
import "./SubscriptionSection.scss";

const SubscriptionSection = ({ title, content, imageSrc }) => {
  const textRef = useRef(null);
  const [lineCount, setLineCount] = useState(1);

  useEffect(() => {
    const calculateLines = () => {
      if (textRef.current) {
        const element = textRef.current;
        const style = window.getComputedStyle(element);
        const lineHeight = parseFloat(style.lineHeight);
        const totalHeight = element.clientHeight;
        const calculated = Math.ceil(totalHeight / lineHeight);
        setLineCount(calculated);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      calculateLines();
    });

    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    requestAnimationFrame(() => calculateLines());

    return () => {
      resizeObserver.disconnect();
    };
  }, [content]);

  return (
    <section className="subscription-section">
      <div className="top-dashed"></div>
      <div className="line-numbers">
        {Array.from({ length: lineCount }, (_, i) => (
          <span key={i} className={i === 0 ? "first-number" : ""}>
            {i + 1}
          </span>
        ))}
      </div>

      <div className="subscription-content">
        <div className="left-section">
          <div className="line-numbers2">
            {Array.from({ length: lineCount }, (_, i) => (
              <span key={i} className={i === 0 ? "first-number" : ""}>
                {i + 1}
              </span>
            ))}
          </div>
          <div>
            <h2 className="subscription-title">{title}</h2>
            <div className="dots2" />

            <p ref={textRef} className="subscription-text">
              {content}
            </p>
          </div>
        </div>
        <div className="top-dashed2"></div>

        <div className="right-section">
          <img src={imageSrc} alt="visual" className="subscription-image" />
        </div>
      </div>
    </section>
  );
};

export default SubscriptionSection;
